export const sourceKeys = {
  all: ['sources'] as const,
  lists: () => [...sourceKeys.all, 'list'] as const,
  list: (
    page: number,
    pageSize: number,
    searchTerm?: string,
    sortBy?: string,
    sortAscending?: boolean,
  ) => [...sourceKeys.lists(), page, pageSize, searchTerm, sortBy, sortAscending] as const,
  details: () => [...sourceKeys.all, 'detail'] as const,
  detail: (id: string) => [...sourceKeys.details(), id] as const,
  mutations: () => [...sourceKeys.all, 'mutation'] as const,
  create: () => [...sourceKeys.mutations(), 'create'] as const,
  edit: (id: string) => [...sourceKeys.mutations(), 'edit', id] as const,
  toggle: () => [...sourceKeys.mutations(), 'toggle'] as const,
  delete: () => [...sourceKeys.mutations(), 'delete'] as const,
};
